// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6170":"095d4669","7371":"66f05de8"}[chunkId] + ".chunk.css";
};